import { ButtonNavStyle } from 'theme/home'

function MillerID() {
  return (
    <ButtonNavStyle className={`button-nav flex items-center justify-center`}>
      <img src={`${AZURE_BASE_URL}/home-miller-basic.webp`} alt='Ir a mi MillerID' className='w-full' />
    </ButtonNavStyle>
  )
}

export default MillerID